import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';

export default function AgentsSection() {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/authorized-agents');
  };

  return (
    <div className="w-full mt-8 flex justify-center px-4">
      <div className="w-full max-w-[1090px]">
        <div className="w-full h-full px-6 lg:px-12 py-8 bg-[#FAFAFA] overflow-hidden rounded-3xl lg:rounded-[64px] outline outline-1 outline-[#E5E7EB] outline-offset-[-1px] flex flex-col lg:flex-row justify-center items-center gap-6 lg:gap-10">
          <div className="flex flex-col justify-start items-start gap-4 lg:gap-6 w-full lg:flex-1 min-w-0">
            <div className="w-full mt-2 text-black text-sm lg:text-base font-avenir space-y-5">
              <p className="font-normal leading-relaxed">
                Our platform is built to be transparent, secure, and human-first. That's why every new investor joins
                Equipool through an Authorized Agent.
              </p>

              <div>
                <p className="font-medium mb-2.5">Our verified agents will:</p>
                <ul className="space-y-2 ml-1">
                  <li className="flex gap-2.5">
                    <span className="text-[#113D7B] font-bold">•</span>
                    <span>Walk you through how Equipool works</span>
                  </li>
                  <li className="flex gap-2.5">
                    <span className="text-[#113D7B] font-bold">•</span>
                    <span>Answer your questions about borrowing or investing</span>
                  </li>
                  <li className="flex gap-2.5">
                    <span className="text-[#113D7B] font-bold">•</span>
                    <span>Help confirm that the platform fits your goals</span>
                  </li>
                  <li className="flex gap-2.5">
                    <span className="text-[#113D7B] font-bold">•</span>
                    <span>Provide you with your personal Qualification Code</span>
                  </li>
                </ul>
              </div>

              <p className="font-normal leading-relaxed">
                This way, you always know who you're working with and where you're signing up — no confusion, no hidden
                steps.
              </p>

              <p className="font-medium">Please contact one of our Authorized Agents to get started.</p>

              <p className="font-medium text-[#113D7B]">Joining Equipool is completely free</p>
            </div>
            <Button onClick={handleClick} variant="primary">
              <img src="/agents.png" className="w-7 h-7" />
              View Authorized Agents
            </Button>
          </div>
          <img
            className="w-full max-w-2xl lg:w-auto lg:max-w-3xl lg:flex-shrink-0 h-auto object-contain"
            src="/agents_home.png"
            alt="Agents home icon"
          />
        </div>
      </div>
    </div>
  );
}
